/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_6_ErrorsInputs */

const en_privacy_section_6_errors = /** @type {(inputs: Privacy_Section_6_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error logs`)
};

const lv_privacy_section_6_errors = /** @type {(inputs: Privacy_Section_6_ErrorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kļūdu žurnāli`)
};

/**
* | output |
* | --- |
* | "Error logs" |
*
* @param {Privacy_Section_6_ErrorsInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_6_errors = /** @type {((inputs?: Privacy_Section_6_ErrorsInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_6_ErrorsInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_6_errors(inputs)
	return en_privacy_section_6_errors(inputs)
});